import BerlitzButton from '@berlitzplatforms/micro.ui.button'
import styled from 'styled-components'

export const Button = styled(BerlitzButton)`
  ${({ theme }) => `
    padding: ${theme.space.xs} ${theme.space.md};
    margin-left: ${theme.space.xs};
  `}
`
